module.exports = {
  API_SERVERS: [
    {
      Name: "IRE",
      URL: "http://lookup-ireland.disctools.co.uk"
    },
    {
      Name: "UK",
      URL: "http://lookup-london.disctools.co.uk"
    },
    {
      Name: "CA",
      URL: "http://lookup-canada.disctools.co.uk"
    },
    {
      Name: "AUS",
      URL: "http://lookup-sydney.disctools.co.uk"
    },
    {
      Name: "North Virginia",
      URL: "http://lookup-northvirginia.disctools.co.uk"
    },
    {
      Name: "North California",
      URL: "http://lookup-northcalifornia.disctools.co.uk"
    },
    {
      Name: "Oregon",
      URL: "http://lookup-oregon.disctools.co.uk"
    },
    {
      Name: "Stockholm",
      URL: "http://eu-north-1.lookup.disctools.co.uk"
    },
    {
      Name: "Ohio",
      URL: "http://lookup-ohio.disctools.co.uk",
    },
    {
      Name: "DEV",
      URL: "http://localhost:8083"
    },
    {
      Name: "Staging",
      URL: "http://apple.disctools.co.uk"
    },
    {
      Name: "Frankfurt",
      URL: "http://eu-central-1.lookup.jeak.co.uk"
    }
  ],
  GetAPIURL() {
    let apiURL = "";
    let selectedServer = localStorage.getItem("APIName");
    if (selectedServer == null) {
      const { Name } = this.API_SERVERS[0];
      selectedServer = Name;
      localStorage.setItem("APIName", selectedServer);
      apiURL = this.API_SERVERS[0].URL;
    } else {
      this.API_SERVERS.forEach(server => {
        if (server.Name === selectedServer) {
          apiURL = server.URL;
        }
      });
    }

    return apiURL;
  },
  GetAPIName() {
    return localStorage.getItem("APIName");
  }
};
